<template>
    <div class="flex items-center">
        <div class="w-4 h-4 rounded border border-custom mr-1" :style="`background: ${option.hex}`"></div>
        <div v-text="option.display"></div>
    </div>
</template>

<script>
export default {
    props: {
        option: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>
.border-custom {
    border-color: rgba(0, 0, 0, .2);
}
</style>

